import React from 'react';
import classNames from 'classnames';
import './GridMessage.css';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';

export const GridMessage = ({
    messageText = null,
    centeredText = false,
    className = null,
}) => {
    const { t } = useTranslations();

    if (messageText === null) {
        return null;
    }

    const textClassNames = classNames(
        'asg-vertical__message-text',
        {
            'asg-vertical__message-text--center': centeredText,
        },
    );

    const rootClassName = classNames(
        'asg-vertical__message',
        className,
    );

    return (<div className={rootClassName}>
        <div className={textClassNames}>{t(messageText)}</div>
    </div>);
};
